module.exports = __webpack_public_path__ + "img/builder-10.ee8c81f7.webp";